/* unplugin-vue-components disabled */import script from "./HotelOrderDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelOrderDetails.vue?vue&type=script&setup=true&lang=js"

import "./HotelOrderDetails.vue?vue&type=style&index=0&id=4b3896cd&lang=scss"

const __exports__ = script;

export default __exports__